import * as types from 'actions/actionTypes';
import initialState from 'reducers/initialState';

export default (state = initialState.diets, action) => {
  switch (action.type) {
    case types.MEAL_SURVEY_DIET_LIST_LOAD.SUCCESS:
      return action.diets;

    case types.LOG_OUT.SUCCESS:
      return initialState.diets;

    default:
      return state;
  }
};
